module.exports = __webpack_public_path__ + "static/et-book-bold-line-figures-1c130d09324dbeb3ba2e5a2f9d788a6f.woff";